// Functions that are useful in both the outer and inner env.
import Logger from "../logger";

// TODO(Austin): Remove this eslint ignore when we have more than one
// function exported.
// eslint-disable-next-line
export const loadLogger = (envData, adexpContextSnapshotFn) => {
  Logger.passContext(
    envData.getLoggingEndpoint(),
    envData.getEventTrackingParam(),
    adexpContextSnapshotFn
  );

  if (envData.getEnableLogging()) {
    Logger.enable();
  }
};



// WEBPACK FOOTER //
// ./src/js/madlib/csp-env/common.js